import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorModeValue,
  useColorMode,
  Image,
  Skeleton,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import axios from "axios";
import apiUrl from "variables/api";
import darkStyles from "variables/darkStyles";
import Creatable from "react-select/creatable";
import { toast } from "react-toastify";
import locations from "variables/locations";

import {
  Editable,
  EditableInput,
  EditableTextarea,
  EditablePreview,
} from "@chakra-ui/react";

import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";

import "./style.css";

registerPlugin();

const initialValues = {
  title: "",
  location: "",
  level: "",
  reason: "",
  conditions: "",
  signatures: [],
  file: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach((field) => {
    if (!values[field] && field !== "irregularities") {
      errors[field] = "To pole jest obowiazkowe";
    }
  });

  if (values.encountered === "TAK" && values.irregularities.length === 0) {
    errors.irregularities = "To pole jest obowiazkowe";
  }

  return errors;
};
function Page() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result); // Ustawiamy podgląd obrazu
      };
      reader.readAsDataURL(file); // Wczytujemy obraz jako URL
    } else {
      setPreview(null); // Resetujemy podgląd, jeśli plik nie jest obrazem
    }
  };
  const [formData, setFormData] = useState(initialValues);

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const formikRef = React.useRef();
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === "file") {
        formData.append(key, values[key]);
      } else {
        formData.append(key, JSON.stringify(values[key]));
      }
    });
    setFormData(values);
    axios
      .post(apiUrl + "/data/k-r-analysis", formData, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          setSelectedFile(null);
          setPreview(null);
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano analizę");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error("Napotkano błąd podczas wysyłania analizy");
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };
  const { colorMode } = useColorMode();

  return (
    <Flex flexDirection="column" pt={{ base: "160px", md: "75px" }}>
      <Card minH="125px">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, values }) => (
            <Form>
              <SimpleGrid
                columns={{ sm: 1, md: 2, xl: 4 }}
                spacing="24px"
                mb="20px"
              >
                <Field name="title">
                  {({ field, form }) => (
                    <FormControl
                      id="title"
                      isRequired
                      isInvalid={form.errors.title && form.touched.title}
                    >
                      <FormLabel>Tytuł inspekcji</FormLabel>
                      <Input {...field} placeholder="Pożar x" />
                      <FormErrorMessage>{form.errors.title}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="location">
                  {({ field, form }) => (
                    <FormControl
                      id="location"
                      isRequired
                      isInvalid={form.errors.location && form.touched.location}
                    >
                      <FormLabel>Lokalizacja</FormLabel>
                      <Creatable
                          {...field}
                          options={locations}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                          formatCreateLabel={(inputValue) => `Niestandardowa: ${inputValue}`}
                        />
                      <FormErrorMessage>
                        {form.errors.location}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="level">
                  {({ field, form }) => (
                    <FormControl
                      id="level"
                      isRequired
                      isInvalid={form.errors.level && form.touched.level}
                    >
                      <FormLabel>Stopień rozwoju</FormLabel>
                      <Input {...field} placeholder="Średni" />
                      <FormErrorMessage>{form.errors.level}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="reason">
                  {({ field, form }) => (
                    <FormControl
                      id="reason"
                      isRequired
                      isInvalid={form.errors.reason && form.touched.reason}
                    >
                      <FormLabel>Przyczyna powstania pożaru</FormLabel>
                      <Input {...field} placeholder="Przyczyna" />
                      <FormErrorMessage>{form.errors.reason}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="conditions">
                  {({ field, form }) => (
                    <FormControl
                      id="conditions"
                      isRequired
                      isInvalid={
                        form.errors.conditions && form.touched.conditions
                      }
                    >
                      <FormLabel>
                        Warunki prowadzenia działań ratowników
                      </FormLabel>
                      <Input {...field} placeholder="Podaj warunki" />
                      <FormErrorMessage>
                        {form.errors.conditions}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="signatures">
                  {({ field, form }) => (
                    <FormControl
                      id="signatures"
                      isRequired
                      isInvalid={
                        form.errors.signatures && form.touched.signatures
                      }
                    >
                      <FormLabel>Podpisy</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values.signatures}
                          isMulti
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      <FormErrorMessage>
                        {form.errors.signatures}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="file">
                  {({ field, form }) => (
                    <FormControl
                      id="file"
                      isRequired
                      isInvalid={form.errors.file && form.touched.file}
                    >
                      <FormLabel>Screenshot</FormLabel>
                      <label htmlFor="file-upload">
                        <input
                          id="file-upload"
                          type="file"
                          accept=".png, .jpg"
                          style={{ display: "none" }} // Ukrywanie domyślnego inputa
                          onChange={(event) => {
                            const file = event.target.files[0];
                            setSelectedFile(file);
                            const filetosend = form.setFieldValue(
                              field.name,
                              file
                            );

                            if (file && file.type.startsWith("image/")) {
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setPreview(reader.result); // Ustawiamy podgląd obrazu
                              };
                              reader.readAsDataURL(file); // Wczytujemy obraz jako URL
                            } else {
                              setPreview(null); // Resetujemy podgląd, jeśli plik nie jest obrazem
                            }
                          }}
                        />
                        <Button as="span" colorScheme="red" variant="solid">
                          Wybierz plik
                        </Button>
                      </label>
                      {selectedFile && (
                        <Text mt={2} fontSize="sm">
                          Wybrany plik: {selectedFile.name}
                        </Text>
                      )}

                      {preview && (
                        <Image
                          src={preview}
                          alt="Podgląd obrazu"
                          height={"100px"} // Ustawienie stałej wysokości podglądu
                          mt={2}
                          objectFit="cover" // Dopasowanie obrazu do pola podglądu
                          borderRadius="md"
                        />
                      )}

                      <FormErrorMessage>{form.errors.file}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                {values.encountered === "TAK" && (
                  <Field name="irregularities">
                    {({ field, form }) => (
                      <FormControl
                        id="irregularities"
                        isRequired
                        isInvalid={
                          form.errors.irregularities &&
                          form.touched.irregularities
                        }
                      >
                        <FormLabel>Wybierz nieprawidłowości</FormLabel>
                        <SimpleGrid>
                          {[
                            "- Nieprawidłowości dotyczące instrukcji postępowania na wypadek pożaru wraz z wykazem telefonów alarmowych",
                            "- Nieprawidłowości dotyczące instrukcji bezpieczeństwa pożarowego",
                            "- Nieprawidłowości dotyczące zaznajomienia z przepisami przeciwpożarowymi",
                            "- Nieprawidłowości dotyczące instalacji użytkowych",
                            "- Nieprawidłowości dotyczące stanu dróg ewakuacyjnych (drożności, skladowania materiałów palnych) i znaków bezpieczeństwa",
                            "- Nieprawidłowości dotyczące dróg pożarowych",
                            "- Nieprawidłowości dotyczące zaopatrzenia w wodę",
                            "- Nieprawidłowości dotyczące dźwiękowych systemów ostrzegawczych",
                            "- Nieprawidłowości dotyczące systemów sygnalizacji pożarowej",
                            "- Nieprawidłowości dotyczące instalacji wodociągowych przeciwpożarowych",
                            "- Nieprawidłowości dotyczące gaśnic",
                            "- Nieprawidłowości dotyczące braku wymaganych oświetleń awaryjnych",
                            "- Nieprawidłowości w zakresie zabezpieczenia przed zadymieniem dróg ewakuacyjnych",
                            "- Nieprawidłowości w zakresie wystroju korytarzy albo pomieszczeń",
                            "- Nieprawidłowości w zakresie długości lub szerokości dróg ewakuacyjnych",
                          ].map((irregularity) => (
                            <CustomCheckbox
                              key={irregularity}
                              label={irregularity}
                              isChecked={field.value.includes(irregularity)}
                              onChange={() => {
                                const nextValue = field.value.includes(
                                  irregularity
                                )
                                  ? field.value.filter(
                                      (value) => value !== irregularity
                                    )
                                  : [...field.value, irregularity];
                                form.setFieldValue(field.name, nextValue);
                              }}
                            />
                          ))}
                        </SimpleGrid>
                        <FormErrorMessage>
                          {form.errors.irregularities}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                )}
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
